/* global Highcharts */
(function () {
  'use strict';

  var id = 'range-chart',
    rangeChartMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'AggregationUtils', '$filter', 'QueryES', 'wsColors', '$sanitize', 'Utils', 'ChartUtils', function (CardQueryResource, AggUtils, $filter, QueryES, wsColors, $sanitize, Utils, ChartUtils) {
    var self = {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        var cardId = cfg.cardId,
          cardToPreview = cfg.cardToPreview,
          path = "/range-chart/data",
          params = cfg.params;
        return CardQueryResource.getWithProgress(path, cardId, params, cardToPreview, 'range-chart-' + cardId);
      },
      areMeasuresCompatible: function areMeasuresCompatible(measures) {
        for (var i = 0, j = 1; j < measures.length; i += 2, j += 2) {
          //get statement properties from the measures if the valueproducer exists (these CAN be null or undefined)
          var vp1 = measures[i].valueProducer || {},
            vp2 = measures[j].valueProducer || {};
          //check if pairs of measures are not of the same type AND looking at duration or scaled score
          if (vp1.valueType !== vp2.valueType && vp1.statementProperty !== vp2.statementProperty && _.intersection(["result.durationCentiseconds", "result.score.scaled"], [vp1.statementProperty, vp2.statementProperty]).length > 0) {
            return false;
          }
        }
        return true;
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      createPointFromAverage: function createPointFromAverage(averages, config) {
        if (!config.showAverage) {
          return null;
        }
        return {
          values: [{
            label: 'Average'
          }],
          aggregations: _.map(averages, function (a, i) {
            return {
              value: a.avg,
              label: AggUtils.getMeasureValueDisplay({
                value: a.avg
              }, config.measures[i])
            };
          })
        };
      },
      getMeasureDifferences: function getMeasureDifferences(aggregations, config) {
        var ret = [];
        //add difference between measures to list
        //set numeric and value producer here for display purposes
        /* jshint loopfunc: true */
        var _loop = function _loop(i, j) {
            a1 = aggregations[i].value && aggregations[i] || {
              label: $sanitize(config.measures[i].name),
              value: aggregations[i].avg
            }, a2 = aggregations[j].value && aggregations[j] || {
              label: $sanitize(config.measures[j].name),
              value: aggregations[j].avg
            };
            val = a2.value - a1.value;
            label = AggUtils.getMeasureValueDisplay({
              value: val
            }, config.measures[i]);
            var hiddenMeasureFound = Utils._try(function () {
              return config.hiddenMeasures.indexOf(i) > -1 || config.hiddenMeasures.indexOf(j) > -1;
            }, false);
            if (hiddenMeasureFound) {
              return 1; // continue
            }
            var rangeValue = {
              label: label,
              value: !_.isNaN(val) ? val : null,
              valueProducer: angular.copy(config.measures[i].valueProducer)
            };
            if (rangeValue.valueProducer.type === "STATEMENT_PROPERTY" && rangeValue.valueProducer.statementProperty === "timestamp") {
              rangeValue.valueProducer.type = "TIME_BETWEEN";
            }
            ret.push(rangeValue);
          },
          a1,
          a2,
          val,
          label;
        for (var i = 0, j = 1; j < aggregations.length; i += 2, j += 2) {
          if (_loop(i, j)) continue;
        }
        /* jshint loopfunc: false */
        return ret;
      },
      createRangePoint: function createRangePoint(a1, a2, valueProducer, highColor, lowColor) {
        var lowLabel = AggUtils.getMeasureValueDisplay(a1, valueProducer);
        var highLabel = null;
        var name = lowLabel;
        var low = a1.value,
          high = a2.value;
        highColor = highColor || wsColors.wsBlue;
        lowColor = lowColor || wsColors.wsRed;

        //return null if low or high are undefined or NaN
        if (!_.isNumber(low) || !_.isNumber(high)) {
          return null;
        }
        var changeValueProducer = angular.copy(valueProducer);
        if (changeValueProducer.valueProducer.type === "STATEMENT_PROPERTY" && changeValueProducer.valueProducer.statementProperty === "timestamp") {
          changeValueProducer.valueProducer.type = "TIME_BETWEEN";
          changeValueProducer.valueProducer.format = "y[y] d[d] h[h] m[m] s[s]";
        }
        if (low !== high) {
          //if the values are not the same show the change as well
          highLabel = AggUtils.getMeasureValueDisplay(a2, valueProducer);
          name += ' to ' + highLabel;
          var change = high - low;
          name += '<br/>(<span style="color: ' + (change < 0 ? lowColor : highColor) + ';">';
          name += AggUtils.getMeasureValueDisplay({
            value: change
          }, changeValueProducer);
          name += change < 0 ? ' decrease' : ' increase';
          name += '</span>)';
        }

        //scale scores out of 100%
        if (valueProducer.statementProperty === "result.score.scaled") {
          low *= 100;
          high *= 100;
        }
        return {
          name: name,
          lowLabel: lowLabel,
          highLabel: highLabel,
          low: low,
          high: high,
          dataLabels: {
            inside: false,
            align: low === high ? 'center' : null,
            verticalAlign: low === high ? 'middle' : null
          },
          color: low > high ? lowColor : highColor
        };
      },
      getRangeChart: function getRangeChart(data, config) {
        var chart = {
          chart: {
            type: 'columnrange',
            inverted: !config.vertical,
            plotBorderWidth: 1
          },
          plotOptions: {
            columnrange: {
              dataLabels: {
                enabled: true,
                useHTML: true,
                formatter: function formatter() {
                  if (this.point.low === this.point.high) {
                    return '<span style="margin-left: 7px;">&#9672; ' + this.point.lowLabel + '</span>';
                  }
                  if (this.y === this.point.low) {
                    return this.point.lowLabel;
                  } else {
                    return this.point.highLabel;
                  }
                }
              }
            }
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: [],
            labels: {
              useHTML: true
            }
          },
          yAxis: [{
            title: null,
            allowDecimals: config.displayAxisDecimals,
            type: config.measures[0].valueProducer.statementProperty === "timestamp" ? "datetime" : null,
            labels: {
              formatter: function formatter() {
                try {
                  if (this.chart.userOptions.info.valProd.valueProducer.statementProperty === "timestamp") {
                    return Highcharts.dateFormat('%b %e, %Y', this.value);
                  } else {
                    return this.value;
                  }
                } catch (e) {
                  return this.value;
                }
              }
            }
          }, {
            title: 'Time',
            opposite: true,
            labels: {
              formatter: function formatter() {
                if (this.value === "Average") {
                  return this.value;
                }
                var chartInfo = this.chart.userOptions.info;
                return AggUtils.getMeasureValueDisplay(this, chartInfo.valProd);
              }
            }
          }],
          tooltip: {
            style: {
              padding: '1px'
            },
            headerFormat: '<div class="watershed-tooltip"><table><thead><tr><th>{point.x}</th></tr></thead>',
            pointFormat: '<tr><td>{series.name}:</td>' + '<td>{point.name}</td></tr>',
            footerFormat: '</table></div>',
            shared: true
          },
          series: [],
          info: {
            valProd: config.measures[0]
          }
        };
        var labelSeries = [];

        //add series to chart for each two measures
        for (var i = 0, j = 1; j < config.measures.length; i += 2, j += 2) {
          var yAxis = 0;
          if (AggUtils.isDurationBasedMeasure(config.measures[i])) {
            yAxis = 1;
          }
          if (config.displayMeasureNames) {
            labelSeries.push({
              type: 'columnrange',
              name: $sanitize(config.measures[i].name + ' - ' + config.measures[j].name),
              yAxis: yAxis,
              data: [],
              dataLabels: {
                enabled: true
              },
              enableMouseTracking: false
            });
          }
          chart.series.push({
            name: $sanitize(config.measures[i].name + ' - ' + config.measures[j].name),
            borderColor: '#FFF',
            color: ChartUtils.getSeriesColor(config, i),
            borderWidth: 2,
            yAxis: yAxis,
            data: []
          });
        }
        _.each(data, function (v) {
          if (!v.values) {
            return;
          }
          var label = v.values[0].label || v.values[0].value;
          var category = label === "Average" ? "Average" : AggUtils.getDimensionDisplay(label, config.dimensions[0]);
          chart.xAxis.categories.push(category);
          var allPointsNull = true;

          //add points for each two measures
          for (var i = 0, j = 1; j < v.aggregations.length; i += 2, j += 2) {
            var p = self.createRangePoint(v.aggregations[i], v.aggregations[j], config.measures[i], ChartUtils.getSeriesColor(config, i), ChartUtils.getSeriesColor(config, j));
            allPointsNull = allPointsNull && !p;
            if (!p) {
              continue;
            }
            chart.series[Math.floor(i / 2)].data.push(p);
            if (config.displayMeasureNames) {
              var avg = p ? (p.low + p.high) / 2 : null;
              labelSeries[Math.floor(i / 2)].data.push({
                name: name,
                low: avg,
                high: avg,
                dataLabels: {
                  enabled: true,
                  inside: true,
                  align: 'center',
                  padding: 0,
                  allowOverlap: true,
                  format: "{series.name}"
                }
              });
            }
          }
          if (allPointsNull) {
            //if all points are null remove the category altogether
            chart.xAxis.categories.pop();
          }
        });
        _.each(labelSeries, function (s, i) {
          chart.series.splice(2 * i, 0, s);
        });
        chart.series = _.filter(chart.series, function (s, i) {
          return Utils._try(function () {
            return config.hiddenMeasures.indexOf(i * 2) < 0 && config.hiddenMeasures.indexOf(i * 2 + 1) < 0;
          }, true);
        });
        return chart;
      },
      getMeasuresAndControls: function getMeasuresAndControls(config) {
        var chartMeasures = [];
        var dimensionLabels = AggUtils.getDimensionLabels({
          config: config,
          context: 'detailView'
        });
        var leaderboardSortControls = [{
          "title": Utils.capitalizeEachWord(Utils._try(function () {
            return dimensionLabels[0] || '';
          }, ''))
        }];
        var measureCount = Utils._try(function () {
          return config.measures.length;
        }, 0);
        /* jshint loopfunc: true */
        var _loop2 = function _loop2(i, j) {
          var hiddenMeasureFound = Utils._try(function () {
            return config.hiddenMeasures.indexOf(i) > -1 || config.hiddenMeasures.indexOf(j) > -1;
          }, false);
          if (hiddenMeasureFound) {
            return 1; // continue
          }
          chartMeasures.push({
            name: config.measures[i].name + ' - ' + config.measures[j].name
          });
          leaderboardSortControls.push({
            "title": Utils.capitalizeEachWord(config.measures[i].name + ' - ' + config.measures[j].name)
          });
        };
        for (var i = 0, j = 1; j < measureCount; i += 2, j += 2) {
          if (_loop2(i, j)) continue;
        }
        /* jshint loopfunc: false */

        return {
          leaderboardSortControls: leaderboardSortControls,
          chartMeasures: chartMeasures
        };
      }
    };
    return self;
  }]).
  // This is essentially initialization logic and for us it's primarily used here to append additional
  // routes for this specific card.
  config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/range/:cardId', {
      templateUrl: 'modules/app/range-chart/range-chart-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/range/:cardId/top', {
      templateUrl: 'modules/app/range-chart/range-chart-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "range": "range"
    });
  }]).controller(id + ".CardConfiguration", ["$scope", '$controller', '$rootScope', id + '.Utils', 'Utils', function ($scope, $controller, $rootScope, RangeUtils, Utils) {
    $scope.tempMeasures = rangeChartMeasures;
    $scope.templateType = "range";
    $scope.sortConfigOptions = {
      sortDirections: ['Ascending', 'Descending', 'Ascending (Absolute)', 'Descending (Absolute)'],
      defaultSort: '-measure[1-0].value',
      measures: RangeUtils.getMeasuresAndControls($scope.workingConfig).chartMeasures
    };

    /**
     * Need to override this function from AggregationCardConfiguration because
     * range charts require special dropdown options as returned from the
     * getMeasuresAndControls function.
     */
    $scope.updateSortConfig = function () {
      var measures = RangeUtils.getMeasuresAndControls($scope.workingConfig).chartMeasures;
      $scope.sortConfig.setOptions($scope.selectedDimension, measures);
    };

    // Overriding this function because it needs to send 'range' as chartType to sortDirective()
    $scope.sortSelected = function () {
      $scope.workingConfig.defaultSort = $scope.sortConfig.sortDirective('range');
      $scope.updateCardWithWorkingConfig();
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });
    function removeRangeSort() {
      var resetSort = Utils._try(function () {
        return $scope.workingConfig.defaultSort.split('-').length > 2;
      }, false);
      if (resetSort) {
        $scope.workingConfig.defaultSort = '-measure[0].label';
        $scope.updateCardWithWorkingConfig();
      }
    }
    $scope.cardChangeHandlers.push(removeRangeSort);
    $scope.rangeChartHelpText = {
      helpTitle: 'Range',
      detailText: "In the Range section, you'll choose how you want to group data (in the Organized " + "menu) and what measures you'll want to see (using the Measures menu). Choose an option in the " + "Organized menu first, and then select as many measures as you'd like by choosing them in the " + "dropdown and clicking Add Measure. Remove a measure by clicking the X next to a selected measure. " + "The Orientation option allows you to choose whether you want your Range report to represent " + "data horizontally or vertically. "
    };
    $scope.$watch("workingConfig.vertical", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);

    // show average should be true by default
    $scope.workingConfig.showAverage = $scope.workingConfig.showAverage !== null ? $scope.workingConfig.showAverage : true;
    $scope.$watch("workingConfig.showAverage", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);

    //clear out any range-chartMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      rangeChartMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', 'CardDisplay', 'ReportValidationService', function ($scope, CardRegistry, Utils, AggUtils, wsEvents, $routeParams, CardDisplay, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.measures = $scope.config.measures;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    $scope.defaultSummary = 'Range chart of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true);
    $scope.getMeasureValueDisplay = AggUtils.getMeasureValueDisplay;
    var previewLimit = 10;
    if ($scope.config.vertical) {
      previewLimit = $scope.measures.length > 2 ? Math.floor(16 / $scope.measures.length) : 8;
    } else {
      previewLimit = $scope.measures.length > 2 ? Math.floor(20 / $scope.measures.length) : 10;
    }
    var fetchCfg = {
      cardId: $scope.cardId || $scope.card.id,
      cardToPreview: $scope.cardToPreview,
      params: {
        _limit: CardDisplay.getLimitParam($scope.cardId || $scope.card.id) || previewLimit,
        order_by: $scope.config.defaultSort || '-measure[1-0].value'
      }
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }
      $scope.data = r.results[0].result.data;
      //make sure the average is in the front
      var average = Utils.createPointFromAverage(r.results[0].result.stats, $scope.config);
      if (average !== null) {
        $scope.data.unshift(average);
      }
      $scope.barChart = Utils.getRangeChart($scope.data, $scope.config);
      $scope.hasData = r.results[0].result.data.length > 0 && $scope.measures.length > 1;
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", "CardRegistry", "CardUtils", id + '.Utils', 'AggregationUtils', 'Utils', '$timeout', 'CardQueryResource', 'wsEventNames', 'ReportValidationService', function ($scope, $routeParams, CardRegistry, CardUtils, Utils, AggUtils, CentralUtils, $timeout, CardQueryResource, wsEventNames, ReportValidationService) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var result = Utils.getMeasuresAndControls($scope.config);
    $scope.chartMeasures = result.chartMeasures;
    var leaderboardSortControls = result.leaderboardSortControls;
    $scope.dimension = {
      name: AggUtils.getDimensionInSentence($scope.config.dimensions[0])
    };
    $scope.sortOptions = ['Ascending', 'Descending', 'Ascending (Absolute)', 'Descending (Absolute)'];
    $scope.sortColumn = $scope.chartMeasures[0];
    $scope.sortDirection = $scope.sortOptions[1];
    var sortConfigOptions = {
      dimension: $scope.dimension,
      measures: $scope.chartMeasures,
      sortDirections: $scope.sortOptions,
      defaultSort: '-measure[1-0].value'
    };
    $scope.sortConfig = AggUtils.sortConfig(sortConfigOptions); // For the sorting dropdowns
    $scope.sortConfig.setSelections($scope.config.defaultSort || $scope.sortConfig.defaultSort);
    $scope.hideMeasures = AggUtils.hideMeasures($scope.config);
    $scope.sort = function (option, direction) {
      $scope.sortConfig.option = option;
      $scope.sortConfig.direction = direction;
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
    $scope.fetchPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
        params: {
          "_limit": limit,
          "_offset": offset,
          "order_by": $scope.sortConfig.sortDirective('range')
        }
      };

      //clear out leaderboard
      $scope.leaderboardDefinition = undefined;
      return Utils.fetchData(fetchCfg).then(function (data) {
        var results = data.results[0].result;
        $scope.hasData = results.data.length > 0;
        $scope.pagenote.setReportMetadata(data);
        $scope.stats = results.stats;
        $scope.pageData = results.data;
        if (!$scope.config.vertical) {
          $scope.chartHeight = 15 * $scope.pageData.length * $scope.config.measures.length + 100 + 'px';
        }
        var average = Utils.createPointFromAverage(data.results[0].result.stats, $scope.config);
        if (average !== null) {
          $scope.pageData.unshift(average);
        }
        $scope.barChart = Utils.getRangeChart($scope.pageData, $scope.config);

        //update leaderboard
        $scope.pageData = _.filter($scope.pageData, function (d) {
          return d.values;
        });
        $scope.list = _.map($scope.pageData, function (d) {
          var name = d.values[0].label ? d.values[0].label : AggUtils.getDimensionDisplay(d.values[0], $scope.config.dimensions[0]);
          return {
            name: name,
            getMeasureValueDisplay: AggUtils.getMeasureValueDisplay,
            measures: Utils.getMeasureDifferences(d.aggregations, $scope.config)
          };
        });
        $scope.leaderboardDefinition = {
          data: {
            allAttempts: {
              results: $scope.list
            },
            firstAttempt: {
              results: []
            },
            lastAttempt: {
              results: []
            },
            bestAttempt: {
              results: []
            }
          },
          templateUrl: 'modules/app/range-chart/leaderboard.html',
          sortControls: leaderboardSortControls,
          listerControls: {
            pageSize: 100,
            sortBy: "ignoresort"
          }
        };
        return results;
      }, function () {
        $scope.hasData = false;
      });
    };
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('range-chart/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
  }]);
})();
